export default "__VITE_ASSET__tMtj4kw2__"